import { useState, type ReactNode } from 'react';
/** Opening a programme is an explicit read; hidden components never subscribe. */
export function ProgrammeDisclosure({label, className, children}: {label: string; className: string; children: ReactNode}) {
  const [open, setOpen] = useState(false);
  return <details className={`rt-disclosure ${className}`} onToggle={(event) => setOpen(event.currentTarget.open)}><summary onClick={() => setOpen((value) => !value)}>{label}</summary>{open && children}</details>;
}
